import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import GstDetails from "../../../../components/_utils/AccountCreationComponents/GstDetails";
import PanDetails from "../../../../components/_utils/AccountCreationComponents/PanDetails";
import CommonLayout from "../../../../components/_utils/CommonLayout";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import CommonToast from "../../../../components/_utils/CommonToast";
import BeneAccountDetailsPopup from "../../../../components/Accounts/BeneAccount/BeneAccountDetailsPopup";
import AssociateAccountEdit from "../../../../containers/Accounts/BeneficiaryEditAccount/AssociateAccountEdit";
import GSTVerification from "../../../../containers/Settings/GSTDetails";
import { beneVerifyThisGST } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  beneLookUp,
  resetPanArchived,
  resetPanUnarchived,
} from "../../../../redux/features/verifyPAN/verifyPAN";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import Validation from "../../../../utils/validation";
import "./index.css";
import RejectingTransactionPopup from "../BeneficiaryAcountApproval/RejectingTransactionPopup/RejectingTransactionPopup";

const BenePanDetails = ({
  verifiedPan,
  panNumber,
  handlePanChange,
  panDetails,
  beneLookData,
  beneLookLoading,
  BenEnableNextButton,
  verifyPANisLoading,
  setIsArchived,
  setIsApproved,
  setIsDennied,
  setIsPending,
  accountType,
  setAccountType,
  setShutViewAll,
  type,
  previousId,
  setIsActive,
  isActive,
  beneLookError,
  setNewMessage,
  setHideBlock,
  hideBlock,
  hideCreate,
  setNonArchive,
  nonArchive,
  setPreviousBankNo,
  isLinkedAccount,
  setIsLinkedAccount,
  alreadyLinked,
  haveLinkNew,
  setPayload,
  payload,
  setShowAccInfo,
  associatedPan,
  setGSTPanExist,
  GSTPanExist,
  showRejectTnxPopup,
  setRejectTxnPopup,
}) => {
  const [isApprovedState, setIsApprovedState] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [customErrors, setCustomErrors] = useState({});
  const [gstVerified, setGstVerified] = useState(null);
  const [beneDetails, setBeneDetails] = useState(false);
  const [beneAccountId, setBeneAccountId] = useState("");
  const [GSTStatus, setGSTStatus] = useState(null);
  const associatedAccountRef = useRef(null);
  const [activeTab, setActiveTab] = useState("Active");
  const [slideDirection, setSlideDirection] = useState("right");
  const dispatch = useDispatch();
  const [GSTLinked, setGSTLinked] = useState(true);
  const [GSTLinkedMessage, setGSTLinkedMessage] = useState(null);
  const [showRejectAllTxnReson, setShowRejectAllTxnReson] = useState(false);
  const [newData, setNewData] = useState({
    gstin: "",
  });

  const [gstTempData, setGstTempData] = useState(null);
  const { viewAccountDetailData, viewAccountDetailLoading } = useSelector(
    (state) => state.verify,
  );

  const { beneVerifyGST, isGSTLoading } = useSelector(
    (state) => state.beneAllVerification,
  );

  useEffect(() => {
    if (payload?.gstin?.length === 15 && !customErrors["gstin"]) {
      setGSTStatus(Validation.allowedGstin(payload.gstin));

      dispatch(beneVerifyThisGST({ search_string: payload.gstin }));
    } else if (payload?.gstin?.length === 15 && customErrors["gstin"]) {
      setGSTStatus(Validation.allowedGstin(payload.gstin));
    }
  }, [payload.gstin]);

  useEffect(() => {
    if (!isGSTLoading) {
      if (beneVerifyGST?.status === true) {
        setGstVerified(true);
      } else if (beneVerifyGST?.status === false) {
        setGstVerified(false);
      }
    }
  }, [beneVerifyGST, isGSTLoading]);

  useEffect(() => {
    if (payload?.gstin?.length === GlobalConfiguration.gstLength) {
      let aa = payload.gstin.substring(
        2,
        payload.gstin.length - GlobalConfiguration.accountminLength,
      );
      if (aa === panNumber && beneVerifyGST?.status === true) {
        setGSTStatus(true);
        setGstVerified(true);
        setGSTLinked(true);
      } else {
        setGSTStatus(false);
        setGstVerified(false);
        if (aa != panNumber && beneVerifyGST?.status === true) {
          setGSTLinked(false);
        }
        BenEnableNextButton(true);
      }
    } else if (!payload?.gstin && verifiedPan && !verifyPANisLoading) {
      setGSTStatus(null);
    }
  }, [
    beneVerifyGST,
    GSTStatus,
    gstVerified,
    payload.gstin,
    verifyPANisLoading,
  ]);

  useEffect(() => {
    if (activeTab === "Active") {
      setIsActive(false);
      setIsApproved(false);
      setIsArchived(false);
      setIsDennied(false);
      setIsPending(false);
    } else if (activeTab === "Inactive") {
      setIsActive(true);
      setIsApproved(false);
      setIsArchived(false);
      setIsDennied(false);
      setIsPending(false);
    }
  }, [activeTab]);

  const ActiveData = () => {
    setIsActive(false);
    setIsDennied(false);
    setIsApproved(false);
    setIsArchived(false);
    if (activeTab === "Inactive") setSlideDirection("left");
    setActiveTab("Active");
    setIsPending(false);
    setNonArchive(false);
    if (haveLinkNew && type === "editFlow") {
      setIsLinkedAccount(true);
      setNewMessage(false);
    } else {
      setIsLinkedAccount(false);
    }
    setAccountType({
      type: "",
      id: "",
    });
    setHideBlock(false);
    setShowAccInfo(false);
  };

  const DeactiveData = () => {
    setIsActive(true);
    setIsDennied(false);
    setIsApproved(false);
    setIsArchived(false);
    setIsPending(false);
    if (activeTab === "Active") setSlideDirection("right");
    setActiveTab("Inactive");
    setNonArchive(false);
    if (haveLinkNew && type === "editFlow") {
      setIsLinkedAccount(true);
      setNewMessage(false);
    } else {
      setIsLinkedAccount(false);
    }
    setShowAccInfo(false);
    setAccountType({
      type: "",
      id: "",
    });
  };

  useEffect(() => {
    let gstStoredData = gstTempData;
    let ActualGstno =
      viewAccountDetailData?.beneficiary_accounts[0]?.gstin_detail;
    let ActualPANno = viewAccountDetailData?.beneficiary_accounts[0]?.pan_no;
    let aa = payload?.gstin?.substring(2, payload?.gstin?.length - 3);
    if (viewAccountDetailLoading === false && viewAccountDetailData != null) {
      if (
        viewAccountDetailData?.beneficiary_accounts[0]?.gstin_detail ===
        undefined
      ) {
        if (!isGSTLoading && gstStoredData != null && payload.gstin !== "") {
          if (payload.gstin?.length === 15 && GSTStatus) {
            let aa = payload.gstin.substring(2, payload.gstin.length - 3);
            if (aa === panNumber) {
              BenEnableNextButton(false);
              setGSTLinked(true);
            } else {
              BenEnableNextButton(true);
              setGSTLinked(false);
              setGSTLinkedMessage(false);
            }
          } else {
            BenEnableNextButton(true);
          }
        } else if (
          verifiedPan &&
          ActualPANno !== panNumber &&
          (GSTStatus == null || !GSTStatus) &&
          payload.gstin?.length === 0
        ) {
          BenEnableNextButton(false);
        } else if (
          verifiedPan &&
          ActualPANno !== panNumber &&
          GSTStatus &&
          payload.gstin?.length === 15
        ) {
          BenEnableNextButton(false);
        } else if (
          verifiedPan &&
          ActualPANno !== panNumber &&
          payload.gstin?.length === 0
        ) {
          BenEnableNextButton(false);
        } else {
          BenEnableNextButton(true);
          setGSTLinked(false);
          setGSTLinkedMessage(false);
        }
      } else if (viewAccountDetailData?.beneficiary_accounts[0]?.gstin_detail) {
        if (!isGSTLoading) {
          if (ActualGstno != gstStoredData && gstStoredData != null) {
            if (payload.gstin?.length == 15 && GSTStatus) {
              let aa = payload.gstin.substring(2, payload.gstin.length - 3);
              if (aa === panNumber && GSTStatus) {
                BenEnableNextButton(false);
                setGSTLinked(true);
                setGSTLinkedMessage(true);
              } else if (aa !== panNumber && GSTStatus) {
                setGSTLinked(false);
                setGSTLinkedMessage(true);
                BenEnableNextButton(true);
              } else {
                BenEnableNextButton(true);
              }
            } else if (panNumber !== ActualPANno && verifiedPan) {
              if (!GSTStatus) {
                BenEnableNextButton(true);
              } else {
                let aa = payload.gstin.substring(2, payload.gstin.length - 3);
                if (aa === panNumber && GSTStatus) {
                  BenEnableNextButton(false);
                  setGSTLinked(true);
                  setGSTLinkedMessage(true);
                } else if (aa !== panNumber && GSTStatus) {
                  setGSTLinked(false);

                  BenEnableNextButton(true);
                } else {
                  BenEnableNextButton(true);
                }
              }
            } else {
              BenEnableNextButton(true);
              setGSTLinked(false);
              setGSTLinkedMessage(false);
            }
          } else if (
            GSTStatus == null &&
            !isGSTLoading &&
            panNumber !== ActualPANno &&
            verifiedPan
          ) {
            BenEnableNextButton(false);
          } else if (GSTStatus && aa !== panNumber) {
            setGSTLinked(false);
          } else if ((GSTStatus || aa === panNumber) && gstVerified) {
            setGSTLinked(true);
            setGSTLinkedMessage(true);
          }
        } else if (ActualGstno == gstStoredData) {
          BenEnableNextButton(true);
          setGSTLinked(true);
          setGSTLinkedMessage(true);
        }
      }
    }
  }, [
    gstTempData,
    payload,
    GSTLinked,
    GSTStatus,
    gstVerified,
    isGSTLoading,
    viewAccountDetailData,
    viewAccountDetailLoading,
  ]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      event.stopPropagation();
      if (
        associatedAccountRef.current &&
        !associatedAccountRef.current.contains(event.target)
      ) {
        setShowAccInfo(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [associatedAccountRef]);

  const modifyValue = (type, value) => {
    if (type === "name") {
      return value?.replace(/(\w)(\w*)/g, function (g1, g2) {
        return g1.toUpperCase() + g2.toLowerCase();
      });
    } else if (type === "gstin") {
      return value?.toUpperCase();
    }
    return value.trim();
  };

  const allowedValue = (name, value) => {
    if (name === "gstin") return Validation.allowedGstin(value);
    return true;
  };
  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };

    if (name === "gstin")
      errors = Validation.validateGstin(name, value, errors);
    setCustomErrors(errors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = modifyValue(name, value.replace(/[^a-zA-Z0-9]/g, ""));
    if (value) {
      setNewData({ [name]: value });
    }
    setNewData((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));

    if (allowedValue(name, value)) {
      validateAndRecordError(name, newValue);
      setPayload((prevState) => ({
        ...prevState,
        [name]: newValue,
      }));

      if (value.trim() === "" && value?.length === 1) {
        return;
      }

      if (name === "gstin") {
        const len = newValue.length;

        setGSTLinked(false);
        setGstVerified(false);

        if (len === GlobalConfiguration.gstLength) {
          setGstTempData(newValue);
          setGSTStatus(false);
        } else if (
          len > GlobalConfiguration.lengthCheckZero &&
          len < GlobalConfiguration.gstLength
        ) {
          setGSTStatus(false);
        } else {
          setGstTempData(null);
          setGSTStatus(null);
        }
      }
    }
  };

  useEffect(() => {
    if (payload.gstin?.length > 0 && beneVerifyGST?.status === true) {
      let errors = { ...customErrors };
      delete errors["gstin"];
      setCustomErrors(errors);
      setGSTStatus(true);
    }

    if (payload.gstin?.length > 0 && beneVerifyGST?.errors) {
      let errors = { ...customErrors };
      errors["gstin"] = beneVerifyGST.errors;
      setCustomErrors(errors);
      setGSTStatus(false);
    }
  }, [beneVerifyGST]);

  const addSpacesToNumber = (number) => {
    return number.replace(/(.{4})/g, "$1 ").trim();
  };

  const navigate = useNavigate();
  const {
    unachivedLoadingPan,
    achivedLoadingPan,
    unachivedDataPan,
    achivedDataPan,
  } = useSelector((state) => state.verify);

  let haveAcheived = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "archived";
  });
  let haveApproved = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "approved";
  });
  let haveDennied = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "denied";
  });
  let haveRejected = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "rejected";
  });
  let havePending = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "pending";
  });
  let haveBlock = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "blocked";
  });

  useEffect(() => {
    let haveApprovedLinked = beneLookData?.beneficiary_accounts?.filter(
      (val) => {
        return val?.id === previousId;
      },
    );

    let haveApprovedNotLinked = beneLookData?.beneficiary_accounts?.filter(
      (val) => {
        return val?.id !== previousId;
      },
    );

    if (haveApprovedLinked && haveApprovedNotLinked) {
      const newData = [...haveApprovedLinked, ...haveApprovedNotLinked];
      setIsApprovedState(newData);
    }
  }, [beneLookData?.beneficiary_accounts]);

  useEffect(() => {
    beneLookData?.beneficiary_accounts?.find((val) => {
      if (val?.id === previousId) {
        setPreviousBankNo(val?.bank_acc_no);
      }
    });
  }, [beneLookData?.beneficiary_accounts]);

  useEffect(() => {
    beneLookData?.beneficiary_accounts?.find((val) => {
      if (val?.id === previousId) {
        setGSTPanExist(val?.gstin_detail ? true : false);
      }
    });
  }, [beneLookData?.beneficiary_accounts]);

  useEffect(() => {
    if (!achivedLoadingPan) {
      if (achivedDataPan?.status === true) {
        dispatch(beneLookUp({ pan_number: panNumber }));
        CommonToast({
          text: "Account archived successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        dispatch(resetPanArchived());
      } else if (achivedDataPan?.status === false) {
        if (achivedDataPan?.errors?.user_unauthorized) {
          navigate("/feature_not_assigned");
        } else {
          CommonToast({
            text: Object.values(achivedDataPan?.errors)[0][0],
            icon: ICONS.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
          dispatch(resetPanArchived());
        }
      }
    }
  }, [achivedDataPan]);

  useEffect(() => {
    if (!unachivedLoadingPan) {
      if (unachivedDataPan?.status === true) {
        dispatch(beneLookUp({ pan_number: panNumber }));
        CommonToast({
          text: "Account unarchived successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });

        setAccountType({ type: "", id: "" });
        dispatch(resetPanUnarchived());
      } else if (unachivedDataPan?.status === false) {
        if (unachivedDataPan?.errors?.user_unauthorized) {
          navigate("/feature_not_assigned");
        } else {
          CommonToast({
            text: Object.values(unachivedDataPan?.errors)[0][0],
            icon: ICONS.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
          dispatch(resetPanUnarchived());
        }
      }
    }
  }, [unachivedDataPan]);

  useEffect(() => {
    if (beneVerifyGST?.gstin_details?.business_name) {
      setPayload({
        ...payload,
        gst_org_name: beneVerifyGST?.gstin_details?.business_name,
      });
    }
  }, [beneVerifyGST]);

  if (GSTPanExist && payload?.gstin?.length == 0) {
    BenEnableNextButton(true);
  }

  const handleClosePopup = () => {
    setRejectTxnPopup(false);
    setShowRejectAllTxnReson(false);
  };

  const closeGSTDetailsModal = () => {
    setShowPopup(false);
  };

  const details =
    !beneLookLoading &&
    !verifyPANisLoading &&
    beneLookError === true &&
    verifiedPan &&
    panNumber?.length === GlobalConfiguration.owneraccountnormalLength;

  return (
    <div className="benePan_Main_edit_pan !mx-auto !my-margin-base !justify-start lg:gap-gap-xl overflow-y-auto overflow-x-hidden w-full">
      {beneDetails && (
        <>
          <BeneAccountDetailsPopup
            closeBeneAccountDetailModal={() => {
              setBeneDetails(false);
            }}
            bene_account_id={beneAccountId}
            type={"bene_account_detail_modal"}
          />
        </>
      )}
      {showRejectTnxPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop opacity-light-opacity">
          <RejectingTransactionPopup
            type={"ArchiveAccount"}
            accountId={accountType.id}
            accountName={viewAccountDetailData?.beneficiary_accounts[0]?.name}
            handleClosePopup={handleClosePopup}
            setShowRejectAllTxnReson={setShowRejectAllTxnReson}
            setRejectTxnPopup={setRejectTxnPopup}
            flow={"edit"}
            setIsDennied={setIsDennied}
            setIsPending={setIsPending}
            setIsApproved={setIsApproved}
            setIsArchived={setIsArchived}
            setShutViewAll={setShutViewAll}
          />
        </div>
      )}

      {showPopup && (
        <div className="fixed top-top_base left-left_base w-screen h-screen flex items-center justify-center z-z-index-modal Qmd:bg-PopUp-BackDrop !bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle="GST Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate("/settings/GST_verification", {
                state: beneVerifyGST?.gstin_details?.gstin_no,
              })
            }
            closeiconhandleFunction={() => setShowPopup(false)}
          >
            <GSTVerification
              gst_number={beneVerifyGST?.gstin_details?.gstin_no}
              closeGSTDetailsModal={closeGSTDetailsModal}
              popup={true}
              setShowPopup={setShowPopup}
              showPopup={showPopup}
            />
          </LargePopupRedirect>
        </div>
      )}

      <div className="  w-full  px-padding-md lg:px-padding-base">
        <CommonLayout>
          <div className="flex flex-col gap-gap-md">
            {(isLinkedAccount || alreadyLinked) && verifiedPan ? (
              <div className=" p-padding-md bg-emphasis rounded-border-radius-md">
                <p className=" text-text-secondary text-font-xs ">
                  Looks like this PAN is already linked to this account. Please
                  change provided PAN details to proceed.
                </p>
              </div>
            ) : hideBlock ? (
              <div className="new_message_text_block mt-margin-lg Qsmd:mt-margin-base">
                <img
                  src={ICONS?.INFO_FILLED}
                  alt="info"
                />
                <p>To unblock this account, please contact customer support</p>
              </div>
            ) : hideCreate ? (
              <div className="new_message_text_block mt-margin-lg Qsmd:mt-margin-base">
                <img
                  src={ICONS?.INFO_FILLED}
                  alt="info"
                />
                <p>
                  Creating a new account adds it to the active accounts for the
                  provided PAN
                </p>
              </div>
            ) : beneLookData?.status &&
              panNumber?.length === 10 &&
              verifiedPan &&
              !associatedPan &&
              viewAccountDetailData?.beneficiary_accounts[0]?.pan_no !==
                panNumber ? (
              <></>
            ) : null}

            {GSTLinkedMessage ? (
              <div className=" p-padding-md bg-emphasis rounded-border-radius-md">
                <h5 className=" text-text-primary text-font-sm font-semibold">
                  Since GST and PAN are linked
                </h5>
                <ul className="list-disc text-font-xs text-text-primary pl-padding-button-l">
                  <li className="my-margin-sm">
                    To edit PAN, the associated GST must also be provided.
                  </li>
                  <li>
                    GST can only be replaced with other GSTs that are associated
                    with the provided PAN.
                  </li>
                </ul>
              </div>
            ) : null}

            <div className="dividepan_edit_pan">
              <PanDetails
                verifiedPan={verifiedPan}
                verifyPANisLoading={verifyPANisLoading}
                panNumber={panNumber}
                handlePanChange={handlePanChange}
                panDetails={panDetails}
              />
            </div>

            <div
              className="dividepan_edit_pan rounded-border-radius-md"
              disabled={type === "editFlow" && !verifiedPan}
              style={{
                backgroundColor:
                  type === "editFlow" && !verifiedPan ? "var(--Blue-3)" : "",
                opacity:
                  type === "editFlow" && !verifiedPan
                    ? "var(--light-opacity)"
                    : "var(--base-opacity)",
              }}
            >
              <GstDetails
                GSTStatus={GSTStatus}
                gstVerified={gstVerified}
                beneVerifyGST={beneVerifyGST}
                isGSTLoading={isGSTLoading}
                GSTLinked={GSTLinked}
                GstNumber={payload.gstin}
                setShowPopup={setShowPopup}
                handleChange={handleChange}
              />
            </div>
          </div>
          <div className="w-width-full flex flex-col h-auto relative">
            {verifiedPan === true ? (
              <div className="w-full flex flex-col flex-1">
                <div className="flex-1">
                  <div className="mx-margin-md lg:mx-margin-base">
                    <AssociateAccountEdit
                      ActiveData={ActiveData}
                      DeactiveData={DeactiveData}
                      haveAcheived={haveAcheived}
                      haveDennied={haveDennied}
                      haveBlock={haveBlock}
                      haveRejected={haveRejected}
                      isApprovedState={isApprovedState}
                      haveApproved={haveApproved}
                      havePending={havePending}
                      isActive={isActive}
                      activeTab={activeTab}
                      setSlideDirection={setSlideDirection}
                      slideDirection={slideDirection}
                      setActiveTab={setActiveTab}
                      previousId={previousId}
                      addSpacesToNumber={addSpacesToNumber}
                      beneLookLoading={beneLookLoading}
                      verifiedPan={verifiedPan}
                      details={details}
                      setAccountId={setBeneAccountId}
                      setAccoutDetails={setBeneDetails}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div
                className="dividepan_edit_pan pan_Details"
                style={{ visibility: "hidden" }}
              ></div>
            )}
          </div>
        </CommonLayout>
      </div>
    </div>
  );
};

export default BenePanDetails;
